import { render } from "./TripleSlider.vue?vue&type=template&id=4071a5f0&scoped=true"
import script from "./TripleSlider.vue?vue&type=script&lang=js"
export * from "./TripleSlider.vue?vue&type=script&lang=js"

import "./TripleSlider.vue?vue&type=style&index=0&id=4071a5f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4071a5f0"]])

export default __exports__